<template>
	<HFWrapper @isNewUi="v => setNewUiflag(v)">
		<div class="pc_wrap" v-bind:class="['rtr_' + currentRoute, { develop }]">
			<div v-if="!isNewUi">
				<Header v-if="!menuChange">
					<menu-routes
						:key="$route"
						:items="gnb_items"
						:class="{ menu_area: false }"
					></menu-routes>
				</Header>
				<HeaderM v-else></HeaderM>
			</div>
			<div :class="!isNewUi && 'container'">
				<router-view></router-view>
			</div>
		</div>
	</HFWrapper>
</template>

<script>
import Header from '@/components/Layout/Header';
import HeaderM from '@/components/Layout/Header.m';
import MenuRoutes from '@/components/Menu/Routes.vue';
import HFW from '../../components/NewUi/Layout/HFW.vue';
// import '@/assets/css/development.css';
export default {
	name: 'DevelopLayout.vue',
	components: {
		Header,
		HeaderM,
		MenuRoutes,
		HFWrapper: HFW,
	},
	props: {
		develop: {
			default: false,
			type: Boolean,
		},
	},
	data() {
		return {
			gnb_items: [
				{
					name: '',
					title: '결제',
				},
				{
					name: '',
					title: '로그인 연동',
				},
				// {
				// 	name: '',
				// 	title: 'menu',
				// },
				// {
				// 	name: '',
				// 	title: 'menu',
				// },
				// {
				// 	name: '',
				// 	title: 'menu',
				// },
			],
			menuChange: window.innerWidth < 1200,
			isNewUi: false,
		};
	},
	computed: {
		currentRoute() {
			return this.$route.name;
		},
	},
	created() {
		window.addEventListener('resize', this.handleResize);
	},
	methods: {
		handleResize() {
			this.width = window.innerWidth;
			this.menuChange = this.width < 1200;
		},
		setNewUiflag(v) {
			this.isNewUi = v;
		},
	},
};
</script>
